import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";

import { Form } from "@shared/components";

export function TermsAndPolicyFields() {
  const translate = useTranslate();

  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 12 }}>
        <Form.Editor
          name="legal_text"
          label={translate("v1/agreement_admin.fields.legal_text")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Editor
          name="privacy_policy"
          label={translate("v1/agreement_admin.fields.privacy_policy")}
        />
      </Grid>
    </Grid>
  )
}
